var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelpHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20.001,
    viewBox: "0 0 20 20.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_89",
    "data-name": "Subtraction 89",
    d: "M2254,122a10,10,0,1,1,10-10A10.012,10.012,0,0,1,2254,122Zm0-7.007a1,1,0,0,0-.709.3,1.509,1.509,0,0,0-.121.15.758.758,0,0,0-.09.18.634.634,0,0,0-.059.18,1.241,1.241,0,0,0,0,.2.843.843,0,0,0,.079.38.9.9,0,0,0,.54.54.943.943,0,0,0,.76,0,.9.9,0,0,0,.54-.54A.988.988,0,0,0,2255,116a1,1,0,0,0-1-1.006Zm0-5.994h0a1,1,0,0,1,0,2,1,1,0,0,0-1,1v1a1,1,0,1,0,2,0v-.18a3,3,0,1,0-3.6-4.32,1,1,0,0,0,.845,1.536h.012a1,1,0,0,0,.873-.536A1,1,0,0,1,2254,109Z",
    transform: "translate(-2244 -102)",
    fill: "#f2824c"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpHover);
export default __webpack_public_path__ + "static/media/helpHover.aa78cb3b2c65abbe12d56965f81b06e7.svg";
export { ForwardRef as ReactComponent };